// client/src/components/CookiesPolicyPage.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import './AgreementsPage.css'; // Shared CSS

function CookiesPolicyPage() {
  const {t} = useTranslation();

  return (
    <div className="policy-page">
      <h1>{t('Agreements.cookiesPolicyTitle')}</h1>
      <p>
        {t('Agreements.cookiesPolicyPlaceholder')}
      </p>
      {/* Add your actual cookies policy content here */}
      
    </div>
  );
}

export default CookiesPolicyPage;